import { combineReducers } from 'redux';
import { deviceReducer, userDeviceIdReducer } from './devices/reducer';
import user from './user/reducer';
import robot from './robot/reducer';
import diag from './diag/reducer';
import monitoring from './monitoring/reducer';
import reminder from './reminder/reducer';
import gminder from './gminder/reducer';
import vehicle from './vehicle/reducer';
import general from './general/reducer';
import periodicMaintenance from './periodicMaintenance/reducer';
import vehicleControl from './vehicleControl/reducer';

const reducers = combineReducers({
  userDeviceId: userDeviceIdReducer,
  device: deviceReducer,
  user,
  robot,
  diag,
  monitoring,
  reminder,
  gminder,
  vehicle,
  general,
  periodicMaintenance,
  vehicleControl,
});

const reducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') return reducers(undefined, action);

  if (action.type === 'SET_STORE_DATA')
    return reducers({ ...state, ...action.payload }, action);

  return reducers(state, action);
};

export default reducer;
